import { createRouter, createWebHistory } from "vue-router";
const AdminDashboard = () =>
  import("@/views/pages/admin-dashboard/admin-dashboard");
const EmployeeDashboard = () =>
  import("@/views/pages/employee-dashboard/employee-dashboard");
const BasicSetup = () => import("@/views/pages/basicsetup/basic-setup");
const Chat = () => import("@/views/pages/apps/chat/chat");
const LeavesEmployee = () =>
  import("@/views/pages/employees/employee-leaves/leaves-employee");
const MyAttendance = () => import("@/views/pages/employees/attendance");
const AttendanceEmployee = () =>
  import("@/views/pages/employees/attendance-employee");
const Overtime = () => import("@/views/pages/employees/overtime");
const OTP = () =>
  import("@/views/pages/pages/authentications/verify-otp/otp.vue");
const Lock_Screen = () =>
  import("@/views/pages/pages/authentications/login/lock-screen.vue");
const Error_500 = () => import("@/views/pages/pages/errors/error-500.vue");
const Error_404 = () => import("@/views/pages/pages/errors/error-404.vue");
const Error_403 = () => import("@/views/pages/pages/errors/error-403.vue");
const Privacy_Policy = () =>
  import("@/views/pages/pages/pages/privacy-policy.vue");
const Faq = () => import("@/views/pages/pages/pages/faq.vue");
const Blank_Page = () => import("@/views/pages/pages/pages/blank-page.vue");
const Terms = () => import("@/views/pages/pages/pages/terms.vue");
const Subscriptions_Company = () =>
  import(
    "@/views/pages/pages/subscriptions/subscriptions-company/subscriptions-company.vue"
  );
const Subscriptions = () =>
  import("@/views/pages/pages/subscriptions/sub/subscriptions.vue");
const Subscribedcompanies = () =>
  import("@/views/pages/pages/subscriptions/subscribedcompanies/subindex");
const Settings = () =>
  import("@/views/pages/administration/settings/settings.vue");
const ChangePassword = () =>
  import("@/views/pages/administration/settings/change-password.vue");
const Activities = () => import("@/views/pages/administration/activities.vue");
const Profile = () =>
  import("@/views/pages/pages/profile/employeeprofile/index");
const MyProject = () =>
  import("@/views/pages/pages/profile/employeeprofile/projectstab.vue");
const ProjectTasks = () =>
  import("@/views/pages/pages/profile/employeeprofile/projectTasks");
const Clientprofile = () =>
  import("@/views/pages/pages/profile/clientprofile/index");
const Projects = () => import("@/views/pages/projects/projects");
const ProjectList = () => import("@/views/pages/projects/project-list");
const Tasks = () => import("@/views/pages/projects/tasks/tasks");
const TaskBoard = () => import("@/views/pages/projects/task-board/task-board");
const ProjectView = () =>
  import("@/views/pages/projects/project-view/project-view");
const Resignation = () => import("@/views/pages/performance/resignation");
const Promotion = () => import("@/views/pages/performance/promotion");
const Training_Type = () =>
  import("@/views/pages/performance/training/training-type");
const Trainers = () => import("@/views/pages/performance/training/trainers");
const Training = () => import("@/views/pages/performance/training/training");
const Goal_Type = () => import("@/views/pages/performance/goals/goal-type");
const Goal_Tracking = () =>
  import("@/views/pages/performance/goals/goal-tracking");
const Performance_Appraisal = () =>
  import("@/views/pages/performance/performance/performance-appraisal");
const Performance_Indicator = () =>
  import("@/views/pages/performance/performance/performance-indicator");
const Performance = () =>
  import("@/views/pages/performance/performance/performance/performance");
const Performance_Setting = () =>
  import(
    "@/views/pages/administration/settings/performance-setting/performance-setting.vue"
  );

// Auth Layouts
const AuthLayout = () => import("@/views/layouts/authentication");
const Register = () => import("@/views/pages/pages/authentications/register");
const Careers = () => import("@/views/pages/careers/careers");
const CareerJob = () => import("@/views/pages/careers/job");
const ApplyJob = () => import("@/views/pages/careers/apply-job");
const ApplyJobFacebook = () => import("@/views/pages/careers/apply-job-facebook");
const ApplyJobIndeed = () => import("@/views/pages/careers/apply-job-indeed");
const ApplyJobLinkedin = () => import("@/views/pages/careers/apply-job-linkedin");
const AdminLayout = () => import("@/views/layouts/admin");

// Employee Routes
const CreateEmployee = () => import("@/views/pages/CreateEmployee.vue");
const ListEmployee = () => import("@/views/pages/employees-list.vue");
const EditEmployee = () => import("@/views/pages/edit-employee.vue");
const EmpHiredCandidates = () => import("@/views/pages/hired-candidates.vue");
const ShiftTiming = () => import("@/views/pages/employees/ShiftTiming.vue");
const Designation = () => import("@/views/pages/employees/designation.vue");
const Department = () => import("@/views/pages/employees/department.vue");
const Employment = () => import("@/views/pages/employees/employment.vue");
const EmploymentForm = () =>
  import("@/views/pages/employees/employment-form.vue");
const CredentialsManagement = () =>
  import("@/views/pages/employees/credentials-management.vue");
const AppIssueReportingList = () =>
  import("@/views/pages/help-support/app-issue-reporting-list.vue");
const AppIssueReportingView = () =>
  import("@/views/pages/help-support/app-issue-reporting-view.vue");
const UserProfile = () =>
  import("@/views/pages/pages/profile/employeeprofile/user-profile");
const CandidateProfile = () =>
  import("@/views/pages/pages/profile/employeeprofile/candidate-profile");

// Basic Setup Routes
const Country = () => import("@/views/pages/basicsetup/Country.vue");
const DutyType = () => import("@/views/pages/basicsetup/duty-type.vue");
const ContractType = () => import("@/views/pages/basicsetup/contract-type.vue");
const EmployeeProject = () =>
  import("@/views/pages/basicsetup/employee-project.vue");
const BreakType = () => import("@/views/pages/basicsetup/break-type.vue");
const BreakTime = () => import("@/views/pages/basicsetup/break-time.vue");
const ShiftTime = () => import("@/views/pages/basicsetup/shift-time.vue");
const ChangeBreakTime = () =>
  import("@/views/pages/basicsetup/change-break-time-requests.vue");
const ChangeShiftTime = () =>
  import("@/views/pages/basicsetup/change-shift-time-requests.vue");
const CareerLevel = () => import("@/views/pages/basicsetup/career-level.vue");
const HigherExactly = () =>
  import("@/views/pages/basicsetup/higher-exactly.vue");
const Experience = () => import("@/views/pages/basicsetup/experience.vue");
const ProvidentFundPayroll = () =>
  import("@/views/pages/basicsetup/provident-fund.vue");
const RecruitmentQuota = () =>
  import("@/views/pages/basicsetup/recruitment-quota.vue");
const AdditionalResourceRequest = () =>
  import("@/views/pages/basicsetup/additional-resource.vue");
const Organization = () => import("@/views/pages/basicsetup/organization.vue");
const Degree = () => import("@/views/pages/basicsetup/degree.vue");
const State = () => import("@/views/pages/basicsetup/State.vue");
const City = () => import("@/views/pages/basicsetup/City.vue");
const ShiftAssign = () => import("@/views/pages/basicsetup/shift-assign.vue");
const GraceTime = () => import("@/views/pages/basicsetup/grace-time.vue");
const PartTime = () => import("@/views/pages/basicsetup/part-time.vue");
const LateComing = () => import("@/views/pages/basicsetup/late-coming.vue");
const HalfDayPolicy = () =>
  import("@/views/pages/basicsetup/half-day-policy.vue");
const HalfDayLeavePolicy = () =>
  import("@/views/pages/basicsetup/half-day-leave-policy.vue");
const AttendanceApprovers = () =>
  import("@/views/pages/basicsetup/attendance-approvers.vue");
const ApprovalTime = () => import("@/views/pages/basicsetup/approval-time.vue");
const ApprovalSandwich = () =>
  import("@/views/pages/basicsetup/approval-sandwich.vue");
const LateAdjustment = () =>
  import("@/views/pages/basicsetup/late-adjustment.vue");
const AutoAttendance = () =>
  import("@/views/pages/basicsetup/auto-attendance.vue");
const LeaveType = () => import("@/views/pages/basicsetup/leave-type.vue");
const LeaveApplicable = () =>
  import("@/views/pages/basicsetup/leaves-applicable.vue");
const LeaveApprover = () =>
  import("@/views/pages/basicsetup/leave-approvers.vue");
const LeaveHistory = () => import("@/views/pages/basicsetup/leave-history.vue");
const LeaveAssign = () => import("@/views/pages/basicsetup/leave-assign.vue");
const Teams = () => import("@/views/pages/basicsetup/teams/team-list.vue");
const BloodGroup = () =>
  import("@/views/pages/basicsetup/teams/blood-group-list.vue");
const MaritalStatus = () =>
  import("@/views/pages/basicsetup/marital-status-list.vue");
const Gender = () => import("@/views/pages/basicsetup/gender.vue");
const Religion = () => import("@/views/pages/basicsetup/religion.vue");
const nationality = () => import("@/views/pages/basicsetup/nationality.vue");
const Division = () => import("@/views/pages/basicsetup/division.vue");
const EmploymentStatus = () =>
  import("@/views/pages/basicsetup/employment-status.vue");
const section = () => import("@/views/pages/basicsetup/section.vue");
const ContactRelation = () =>
  import("@/views/pages/basicsetup/contact-relation.vue");
const DocumentType = () => import("@/views/pages/basicsetup/document-type.vue");
const Campaign = () => import("@/views/pages/basicsetup/campaign.vue");
const LeaveRenewal = () => import("@/views/pages/basicsetup/leave-renewal.vue");
const LeaveApprovalTimeline = () =>
  import("@/views/pages/basicsetup/leave-approval-timeline.vue");
const LeaveRequestTimeline = () =>
  import("@/views/pages/basicsetup/leave-request-timeline.vue");
const TypeForm = () => import("@/views/pages/basicsetup/type-form.vue");
const CustomField = () => import("@/views/pages/basicsetup/custom-field.vue");
const GeoFencing = () => import("@/views/pages/basicsetup/geo-fencing.vue");
const GeoFencingCreate = () =>
  import("@/views/pages/basicsetup/geo-fencing-create.vue");
const GeoFencingEdit = () =>
  import("@/views/pages/basicsetup/geo-fencing-edit.vue");
const GeoFencingMap = () =>
  import("@/views/pages/basicsetup/geo-fencing-map.vue");
const RemoteGeofenceCreation = () =>
  import("@/views/pages/remote/geofence-creation.vue");
const RemoteGeofenceAssignment = () =>
  import("@/views/pages/remote/geofence-assignment.vue");
const Bank = () => import("@/views/pages/basicsetup/bank.vue");
const InterviewType = () =>
  import("@/views/pages/basicsetup/InterviewType.vue");
const InventoryType = () => import("@/views/pages/asset/inventory.vue");
const ServiceType = () => import("@/views/pages/asset/service.vue");

// Control Panel routes
const EmploymentLevel = () =>
  import("@/views/pages/control-panel/employment-level.vue");
const EmploymentGrade = () =>
  import("@/views/pages/control-panel/employment-grade.vue");
const GeneralSettings = () =>
  import("@/views/pages/control-panel/general-settings.vue");

// Asset routes
const AssetType = () => import("@/views/pages/asset/asset-type.vue");
const AssetDetails = () => import("@/views/pages/asset/asset-details.vue");
const Asset = () => import("@/views/pages/asset/asset.vue");
const AssetTabs = () => import("@/views/pages/asset/asset-tabs.vue");
const AssetRequests = () => import("@/views/pages/asset/asset-requests.vue");
const ServiceRequests = () =>
  import("@/views/pages/asset/service-requests.vue");
const RequestAsset = () => import("@/views/pages/asset/request-asset.vue");
const RequestService = () => import("@/views/pages/asset/request-service.vue");
const ServiceTabs = () => import("@/views/pages/asset/service-tabs.vue");
const ServiceRecords = () => import("@/views/pages/asset/service-records.vue");
const InventoryTabs = () => import("@/views/pages/asset/inventory-tabs.vue");
const CardTabs = () => import("@/views/pages/asset/card-tabs.vue");
const RequestInventory = () =>
  import("@/views/pages/asset/request-inventory.vue");
const InventoryDetails = () =>
  import("@/views/pages/asset/inventory-details.vue");
const Assets = () => import("@/views/pages/asset/my-asset-services");

const Card = () => import("@/views/pages/asset/card.vue");
const AssignCard = () => import("@/views/pages/asset/assign-card.vue");
const CardRequest = () => import("@/views/pages/asset/card-request.vue");

// Attendance routes
const Devices = () => import("@/views/pages/attendence/Devices.vue");
const DeviceType = () => import("@/views/pages/attendence/device-type.vue");
const AttendanceFlag = () =>
  import("@/views/pages/attendence/attendance-flag.vue");
const AttendanceHistory = () =>
  import("@/views/pages/attendence/attendance-history.vue");
const TimeAdjustmentRequest = () =>
  import("@/views/pages/attendence/time-adjustment-request.vue");
const NCNS = () => import("@/views/pages/attendence/ncns.vue");
const Suspension = () => import("@/views/pages/attendence/suspension.vue");
const CheckAttendance = () =>
  import("@/views/pages/attendence/check-attendance.vue");
const CheckInOut = () => import("@/views/pages/attendence/check-in-out.vue");
const AttendanceAdmin = () =>
  import("@/views/pages/attendence/attendance-admin.vue");
const Roster = () =>
  import("@/views/pages/attendence/roster.vue");
const WfhAttendanceLogs = () =>
  import("@/views/pages/employees/wfh-attendance-logs.vue");
const RequestBreakTimeChange = () =>
  import("@/views/pages/attendence/request-break-time-change.vue");
const RequestShiftTimeChange = () =>
  import("@/views/pages/attendence/request-shift-time-change.vue");

// My Team routes
const MyTeamDashboard = () =>
  import("@/views/pages/my-team/my-team-dashboard.vue");
const TeamManagement = () =>
  import("@/views/pages/my-team/team-management.vue");
const TeamAttendance = () =>
  import("@/views/pages/my-team/team-attendance.vue");
const TeamLeave = () => import("@/views/pages/my-team/team-leave.vue");
const Project = () => import("@/views/pages/my-team/project.vue");
const Achievement = () => import("@/views/pages/my-team/achievement.vue");
const DisciplinaryActions = () =>
  import("@/views/pages/my-team/disciplinary-action.vue");
const MyTeamPerformanceOverview = () =>
  import("@/views/pages/my-team/overview/overview.vue");
const AchievementList = () =>
  import("@/views/pages/performance-and-rewards/achievement-list");
const DisciplinaryActionsList = () =>
  import("@/views/pages/performance-and-rewards/disciplinary-action-list.vue");
const PerformanceAchievement = () =>
  import("@/views/pages/performance/achievement-list.vue");
const PerformanceDisciplinaryActions = () =>
  import("@/views/pages/performance/disciplinary-action-list.vue");
const PeformanceAndRewardsDashboard = () =>
  import("@/views/pages/performance-and-rewards/dashboard/dashboard.vue");

// Holiday Management
const WeeklyHoliday = () =>
  import("@/views/pages/holiday-management/weekly-holiday.vue");
const GazetteHoliday = () =>
  import("@/views/pages/holiday-management/gazette-holiday.vue");

// Letter Management
const LetterApplicable = () =>
  import("@/views/pages/letter-management/letter-applicable.vue");
const LetterType = () =>
  import("@/views/pages/letter-management/letter-type.vue");
const GenerateLetter = () =>
  import("@/views/pages/letter-management/generate-letter.vue");
import store from "@/store";

// Organization
const Handbook = () => import("@/views/pages/organization/handbook.vue");
const EssHrManual = () =>
  import("@/views/pages/organization/ess-hr-manual.vue");
const HandbookDetails = () =>
  import("@/views/pages/organization/handbook-details.vue");
const HrManual = () => import("@/views/pages/organization/hr-manual.vue");
//news letter
const NewsLetter = () => import("@/views/pages/organization/news-letter.vue");
//week poll
const WeekPoll = () => import("@/views/pages/organization/week-poll.vue");
// Targets
const MyTargets = () => import("@/views/pages/targets/my-target.vue");

// Payroll Management
const PayrollDashboard = () =>
  import("@/views/pages/payroll-management/payroll-dashboard.vue");
const TaxSlab = () => import("@/views/pages/payroll-management/tax-slab.vue");
const IncrementApprovalList = () =>
  import("@/views/pages/payroll-management/increment-approval-list.vue");
const PendingPayroll = () =>
  import("@/views/pages/payroll-management/pending-payroll.vue");
const ApprovedPayroll = () =>
  import("@/views/pages/payroll-management/approved-payroll.vue");
const BudgetPayroll = () =>
  import("@/views/pages/payroll-management/budget-payroll.vue");
const GeneratePayroll = () =>
  import("@/views/pages/payroll-management/generate-payroll.vue");
const PayrollView = () =>
  import("@/views/pages/payroll-management/payroll-view.vue");
const PayrollAdjustmentCategory = () =>
  import("@/views/pages/payroll-management/payroll-adjustment-category.vue");
const PayrollAdjustment = () =>
  import("@/views/pages/payroll-management/payroll-adjustment.vue");
const PayrollAdjustmentView = () =>
  import("@/views/pages/payroll-management/payroll-adjustment-view.vue");
const BulkAdjustmentUpload = () =>
  import("@/views/pages/payroll-management/bulk-adjustment-upload.vue");
const SalarySlips = () =>
  import("@/views/pages/payroll-management/salary-slips.vue");
const SalarySlipView = () =>
  import("@/views/pages/payroll-management/salary-slip-view.vue");
const SalarySlipUserView = () =>
  import("@/views/pages/payroll-management/salary-slip-user-view.vue");
const SalaryType = () =>
  import("@/views/pages/payroll-management/salary-type.vue");
const Salary = () => import("@/views/pages/payroll-management/salary.vue");
const CreateSalary = () =>
  import("@/views/pages/payroll-management/create-salary/create-salary.vue");
const PaymentMods = () =>
  import("@/views/pages/payroll-management/payment-mode.vue");
const SalarySlipEmployees = () =>
  import("@/views/pages/payroll-management/salary-slip-employees.vue");
const TaxOverride = () =>
  import("@/views/pages/payroll-management/tax-override.vue");

// Id Card Management
const IdCardTemplate = () =>
  import("@/views/pages/id-card-management/template.vue");
const IdCardAdmin = () =>
  import("@/views/pages/id-card-management/id-card-admin.vue");
const IdCardEss = () =>
  import("@/views/pages/id-card-management/id-card-ess.vue");

// Probation Evaluation
const MyProbationDetails = () =>
  import("@/views/pages/probation-evaluation/my-probation-details.vue");
const ManagerProbationEvaluation = () =>
  import("@/views/pages/probation-evaluation/manager-probation-evaluation.vue");
const ProbationDetails = () =>
  import("@/views/pages/probation-evaluation/probation-details.vue");
const ProbationEvaluation = () =>
  import("@/views/pages/probation-evaluation/probation-evaluation.vue");
const NcnsType = () => import("@/views/pages/payroll-management/ncns-type.vue");

// Recruitment
const RecruitmentDashboard = () =>
  import("@/views/pages/recruitment/recruitment-dashboard.vue");
const RecruitmentRequisition = () =>
  import("@/views/pages/recruitment/recruitment-requisition.vue");
const ManageApplicants = () =>
  import("@/views/pages/recruitment/manage-applicants.vue");
const AptitudeTest = () =>
  import("@/views/pages/recruitment/aptitude-test.vue");
const CandidateAptitudeTest = () =>
  import("@/views/pages/recruitment/candidate-aptitude-test.vue");
const TestResults = () => import("@/views/pages/recruitment/test-results.vue");
const RequisitionPlanning = () =>
  import("@/views/pages/recruitment/requisition-planning.vue");
const OpenVacancies = () =>
  import("@/views/pages/recruitment/open-vacancies.vue");
const OfferLetter = () => import("@/views/pages/recruitment/offer-letter.vue");
const CandidateDetailForm = () =>
  import("@/views/pages/recruitment/candidate-detail-form.vue");
const OfferLetterTab = () =>
  import("@/views/pages/recruitment/offer-letter-tab.vue");
const CvBank = () => import("@/views/pages/recruitment/cv-bank.vue");
const InternalJobOpenings = () =>
  import("@/views/pages/recruitment/internal-job-openings.vue");
const MyReferrals = () => import("@/views/pages/recruitment/my-referrals.vue");
const Referrals = () => import("@/views/pages/recruitment/referrals.vue");
const InterviewLogs = () =>
  import("@/views/pages/recruitment/interview-logs.vue");
const CandidateInformation = () =>
  import("@/views/pages/recruitment/candidate-information.vue");
const RecruitmentCreateEmployee = () =>
  import("@/views/pages/recruitment/create-employee.vue");

// Role Management
const RolesAndPermissions = () =>
  import("@/views/pages/role-management/roles-and-permissions.vue");
const Permissions = () =>
  import("@/views/pages/role-management/permissions.vue");
const AssignRole = () =>
  import("@/views/pages/role-management/assign-role.vue");
const ModuleBasedAccess = () =>
  import("@/views/pages/role-management/module-based-access.vue");

// Performance
const PerformanceDashboard = () =>
  import("@/views/pages/performance/performance-dashboard.vue");
const ProjectType = () => import("@/views/pages/performance/project-type.vue");
const Form = () =>
  import("@/views/pages/performance/evaluation/evolution-form.vue");
const AssignForm = () =>
  import("@/views/pages/performance/assign-form/assign-form.vue");
const PerformanceReview = () =>
  import("@/views/pages/performance/review-submission.vue");
const FormFrequency = () =>
  import("@/views/pages/performance/form-frequency.vue");
const CreateForm = () =>
  import("@/views/pages/performance/evaluation/create-evolution-form.vue");
const UpdateForm = () =>
  import("@/views/pages/performance/update-evolution-form.vue");
const Feedback = () =>
  import("@/views/pages/performance/feedback/feedback.vue");
const CreatePerformanceReview = () =>
  import("@/views/pages/performance/create-performance-review.vue");
const UpdatePerformanceReview = () =>
  import("@/views/pages/performance/update-performance-review.vue");
const MyForms = () => import("@/views/pages/performance/my-forms.vue");
const PerformanceReport = () =>
  import("@/views/pages/performance/performance-report.vue");
const Appraisals = () =>
  import("@/views/pages/performance/appraisals/appraisals.vue");
const SelfAssesment = () =>
  import("@/views/pages/performance-and-rewards/self-assesment.vue");
const CreateSelfAssesment = () =>
  import("@/views/pages/performance-and-rewards/create-self-assesment.vue");
const Assesments = () =>
  import("@/views/pages/performance/team-evaluation/assessments.vue");
const MyAssesment = () =>
  import(
    "@/views/pages/performance-and-rewards/my-assessment/my-assessment.vue"
  );
const MyFeedback = () =>
  import("@/views/pages/performance-and-rewards/my-feedbacks/feedback.vue");
const AssessmentReport = () =>
  import(
    "@/views/pages/performance/assessment-report/assessment-report-main.vue"
  );
const PeerAssessment = () =>
  import("@/views/pages/performance-and-rewards/peer-assessment.vue");
const InstallationFormWizard = () => import("@/views/pages/installation-form-wizard/index.vue")
import {
  allPermissionsWithRoutes,
  allPermissionsWithRoute,
} from "@/staticData";
import { loadTawkTo } from "@/utils";
import AttendanceComprehensiveReport from "@/views/pages/reports-and-analytics/attendance-comprehensive-report.vue";

const EmailTemplate = () =>
  import("@/views/pages/basicsetup/EmailTemplate.vue");
// const Notifications = () => import("@/views/pages/administration/activities.vue");
const AssignTarget = () => import("@/views/pages/employees/assign-target.vue");
const AssignEmployeeTarget = () =>
  import("@/views/pages/employees/assign-employee-target.vue");
const Termination = () => import("@/views/pages/employees/terminations.vue");
const EmployeePromotion = () => import("@/views/pages/employees/promotion.vue");
const EmployeeDocument = () =>
  import("@/views/pages/employees/employee-document.vue");
const NotificationType = () =>
  import("@/views/pages/notification-panel/notification-type.vue");
const InsuranceCard = () =>
  import("@/views/pages/basicsetup/insurance-card.vue");
const OrganizationSettings = () =>
  import("@/views/pages/control-panel/organization-settings.vue");
const EmployeeSettings = () =>
  import("@/views/pages/control-panel/employee-settings.vue");
const LetterSettings = () =>
  import("@/views/pages/control-panel/letter-settings.vue");
const ModuleSettings = () =>
  import("@/views/pages/control-panel/module-settings.vue");
const PerformanceSettings = () =>
  import("@/views/pages/control-panel/performance-settings.vue");
const ApprolvalSettings = () =>
  import("@/views/pages/control-panel/approval-settings.vue");
const NotificationSettings = () =>
  import("@/views/pages/control-panel/notification-settings.vue");
const ApplicationSettings = () =>
  import("@/views/pages/control-panel/application-settings.vue");
const LetterRequests = () =>
  import("@/views/pages/letter-management/letter-requests.vue");
const IssueLetter = () =>
  import("@/views/pages/letter-management/issue-letter.vue");
const UpdateIncident = () =>
  import("@/views/pages/letter-management/update-issued-letter.vue");
const AllPolicies = () =>
  import("@/views/pages/letter-management/all-policies.vue");
const AddPolicy = () =>
  import("@/views/pages/letter-management/add-policy.vue");
const SelectLetterType = () =>
  import("@/views/pages/letter-management/select-letter-type.vue");
const AddIncident = () =>
  import("@/views/pages/letter-management/add-incident.vue");
const AllIncidents = () =>
  import("@/views/pages/letter-management/all-incidents.vue");
const AllLetters = () =>
  import("@/views/pages/letter-management/all-letters.vue");
const AddLetter = () =>
  import("@/views/pages/letter-management/add-letter.vue");
const UpdateLetter = () =>
  import("@/views/pages/letter-management/update-letter-template.vue");
const AcceptLetter = () =>
  import("@/views/pages/recruitment/accept-letter.vue");
const MyLetter = () =>
  import("@/views/pages/pages/profile/employeeprofile/letters/letters.vue");
const MyLoanRequests = () => import("@/views/pages/asset/my-loan-requests.vue");
const LoanRequests = () => import("@/views/pages/asset/loan-requests.vue");
const MyAdvanceSalaryRequests = () =>
  import("@/views/pages/asset/my-advance-salary-requests.vue");
const AdvanceSalaryRequests = () =>
  import("@/views/pages/asset/advance-salary-requests.vue");
const MyPortal = () => import("@/views/pages/portal/my-portal.vue");
const MyStars = () => import("@/views/pages/stars/my-stars.vue");
const RedemptionRequest = () =>
  import("@/views/pages/stars/redemption-request.vue");
const Notifications = () =>
  import("@/views/pages/notification-panel/notifications.vue");

// Reports and analytics
const RecruitmentReports = () =>
  import("@/views/pages/reports-and-analytics/recruitment-reports.vue");
const EmployeeManagementReports = () =>
  import("@/views/pages/reports-and-analytics/employee-management-reports.vue");
const PerformanceManagementReports = () =>
  import(
    "@/views/pages/reports-and-analytics/performance-management-reports.vue"
  );
const PayrollReports = () =>
  import("@/views/pages/reports-and-analytics/payroll-reports.vue");
const TeamManagementReports = () =>
  import("@/views/pages/reports-and-analytics/team-management-reports.vue");
const AdditionalReports = () =>
  import("@/views/pages/reports-and-analytics/additional-reports.vue");
const BasicReports = () =>
  import("@/views/pages/reports-and-analytics/basic-reports.vue");
const TimeAndAttendanceReports = () =>
  import("@/views/pages/reports-and-analytics/time-and-attendance-reports.vue");
const AdhocReport = () =>
  import("@/views/pages/reports-and-analytics/adhoc-report.vue");
const ProductiveHoursReport = () =>
  import("@/views/pages/reports-and-analytics/productive-hours-report.vue");
const AttendanceSummary = () =>
  import("@/views/pages/reports-and-analytics/attendance-summary.vue");
const AttendanceDetailReport = () =>
  import("@/views/pages/reports-and-analytics/attendance-detail-report.vue");
const AttendanceConsolidatedReport = () =>
  import("@/views/pages/reports-and-analytics/attendance-consolidated-report.vue");
const BreakTimeReport = () =>
  import("@/views/pages/reports-and-analytics/break-time-report.vue");
const LeaveReports = () =>
  import("@/views/pages/reports-and-analytics/leave-reports/index.vue");
const ArrearsReport = () =>
  import("@/views/pages/reports-and-analytics/arrears-report.vue");
const AttendanceComprehensiceReport = () =>
  import("@/views/pages/reports-and-analytics/attendance-comprehensive-report.vue");
const HrDocuments = () => import("@/views/pages/organization/hr-documents.vue");
const BulkUpload = () => import("@/views/pages/employees/BulkUpload.vue");
const ProjectDetails = () =>
  import("@/views/pages/projects/project-view/project-details.vue");
const NoticeBoard = () =>
  import("@/views/pages/notification-panel/notice-board.vue");
const BulkAttendance = () =>
  import("@/views/pages/attendence/bulk-attendance.vue");
const AttendanceDeviceLogs = () =>
  import("@/views/pages/attendence/attendance-import-machiene.vue");
const AttendanceDeviceImport = () =>
  import("@/components/bulk-imports.vue");
const BulkEmployeeCreate = () =>
  import("@/views/pages/bulk-employee-create.vue");
const BulkEmployeeUpdate = () =>
  import("@/views/pages/bulk-employee-update.vue");
const BulkEmployeeProfile = () =>
  import("@/views/pages/bulk-employee-profile.vue");
const BulkLeave = () => import("@/views/pages/basicsetup/bulk-leave.vue");
const BulkLeaveAssign = () =>
  import("@/views/pages/basicsetup/bulk-leave-assign.vue");
const BulkSalaryAdd = () =>
  import("@/views/pages/payroll-management/create-salary/bulk-salary-add.vue");
const BulkIncrementAdd = () =>
  import(
    "@/views/pages/payroll-management/create-salary/bulk-increment-add.vue"
  );
const BulkLetters = () =>
  import("@/views/pages/letter-management/bulk-letters.vue");
const BulkPfAdd = () =>
  import("@/views/pages/payroll-management/bulk-pf-add.vue");
const BulkUpdateAccountDetails = () =>
  import("@/views/pages/payroll-management/bulk-update-account-details.vue");
const BulkAddRoster = () =>
  import("@/views/pages/attendence/bulk-add-roster.vue");
const RosterAdd = () =>
  import("@/views/pages/attendence/roster-add.vue");
const BulkCredentials = () =>
  import("@/views/pages/employees/bulk-credentials.vue");
const BulkUpdateRoster = () =>
  import("@/views/pages/attendence/bulk-update-roster.vue");
const RosterView = () =>
  import("@/views/pages/attendence/roster-view.vue");
const TwoFactorAuthentication = () =>
  import("@/views/pages/administration/settings/two-factor-authentication.vue");

const appVariant = process.env.VUE_APP_VARIANT || "default";

const routes = [
  {
    path: "/",
    component: AuthLayout,
    children: [
      {
        name: "login",
        path: "/",
        component: () =>
          import(
            `@/views/pages/pages/authentications/login/login-${appVariant}.vue`
          ),
      },
      {
        name: "register",
        path: "/register",
        component: Register,
      },
      {
        name: "forgot-password",
        path: "/forgot-password",
        // component: ForgotPassword,
        component: () =>
          import(
            `@/views/pages/pages/authentications/forgot-password/forgot-password-${appVariant}.vue`
          ),
      },
      {
        name: "reset-password",
        path: "/reset-password",
        component: () =>
          import(
            `@/views/pages/pages/authentications/reset-password/reset-password-${appVariant}.vue`
          ),
      },
      {
        name: "verify-otp",
        path: "/verify-otp:email",
        component: () =>
          import(
            `@/views/pages/pages/authentications/verify-otp/verify-otp-${appVariant}.vue`
          ),
      },
      {
        name: "verify-login-otp",
        path: "/verify-login-otp",
        component: () =>
          import(
            `@/views/pages/pages/authentications/verify-login-otp/verify-login-otp-${appVariant}.vue`
          ),
      },
      {
        name: "careers",
        path: "/careers",
        component: Careers,
      },
      {
        name: "career-job",
        path: "/careers/:id",
        component: CareerJob,
      },
      {
        name: "apply-job",
        path: "/apply/:id",
        component: ApplyJob,
      },
      {
        name: "apply-job-facebook",
        path: "/apply/:id/facebook",
        component: ApplyJobFacebook,
      },
      {
        name: "apply-job-indeed",
        path: "/apply/:id/indeed",
        component: ApplyJobIndeed,
      },
      {
        name: "apply-job-linkedin",
        path: "/apply/:id/linkedin",
        component: ApplyJobLinkedin,
      },
      {
        name: "candidate-detail-form",
        path: "/recruitment/candidate-detail-form/:slug",
        component: CandidateDetailForm,
      },
      {
        name: "installation-form-wizard",
        path: "/installation-form-wizard",
        component: InstallationFormWizard,
      },
    ],
  },
  {
    path: "/",
    component: AdminLayout,
    children: [
      {
        path: "/chat",
        name: "chat",
        component: Chat,
      },
      {
        path: "/notifications",
        name: "notifications",
        component: Notifications,
      },
      {
        path: "/employee-dashboard",
        name: "employee-dashboard",
        component: EmployeeDashboard,
      },
      {
        path: "/admin-dashboard",
        name: "admin-dashboard",
        component: AdminDashboard,
        meta: { requiresAuth: true },
      },
      {
        name: "create-employee",
        path: "/employee/create-employee",
        component: CreateEmployee,
      },
      {
        name: "list-employee",
        path: "/employee/list-employee",
        component: ListEmployee,
      },
      {
        name: "edit-employee",
        path: "/employee/edit-employee/:id",
        component: EditEmployee,
      },
      {
        name: "hired-candidates",
        path: "/employee/hired-candidates",
        component: EmpHiredCandidates,
      },

      {
        name: "shift-timing",
        path: "/employee/shift-timing",
        component: ShiftTiming,
      },

      {
        name: "assign-target",
        path: "/employee/assign-target",
        component: AssignTarget,
      },

      {
        name: "assign-employee-target",
        path: "/employee/assign-employee-target",
        component: AssignEmployeeTarget,
      },

      {
        name: "termination",
        path: "/employee/termination",
        component: Termination,
      },
      {
        name: "promotion",
        path: "/employee/promotion",
        component: EmployeePromotion,
      },

      {
        name: "bulk-upload",
        path: "/employee/bulk-upload",
        component: BulkUpload,
      },
      {
        name: "bulk-employee-add",
        path: "/employee/bulk-employee-add",
        component: BulkEmployeeCreate,
      },
      {
        name: "bulk-employee-update",
        path: "/employee/bulk-employee-update",
        component: BulkEmployeeUpdate,
      },
      {
        name: "bulk-employee-profile",
        path: "/employee/bulk-employee-profile",
        component: BulkEmployeeProfile,
      },
      {
        name: "bulk-attendance",
        path: "/attendance/bulk-attendance",
        component: BulkAttendance,
      },
      {
        name: "attendance-device-logs",
        path: "/attendance/attendance-device-logs",
        component: AttendanceDeviceLogs,
      },
      {
        name: "attendance-device-import",
        path: "/attendance/attendance-device-import",
        component: AttendanceDeviceImport,
      },
      {
        name: "bulk-leave",
        path: "/leave/bulk-leave",
        component: BulkLeave,
      },
      {
        name: "bulk-leave-assign",
        path: "/leave/bulk-leave-assign",
        component: BulkLeaveAssign,
      },
      {
        name: "bulk-letters",
        path: "/letter-management/bulk-letters",
        component: BulkLetters,
      },
      {
        name: "bulk-salary",
        path: "/payroll/bulk-salary",
        component: BulkSalaryAdd,
      },
      {
        name: "bulk-increment",
        path: "/payroll/bulk-increment",
        component: BulkIncrementAdd,
      },
      {
        name: "bulk-pf",
        path: "/payroll/bulk-pf",
        component: BulkPfAdd,
      },
      {
        name: "bulk-update-account-details",
        path: "/payroll/bulk-update-account-details",
        component: BulkUpdateAccountDetails,
      },
      {
        name: "bulk-add-roster",
        path: "/attendance/bulk-add-roster",
        component: BulkAddRoster,
      },
         {
        name: "roster-add",
        path: "/attendance/roster-add",
        component: RosterAdd,
      },
      {
        name: "roster-view",
        path: "/attendance/roster-view",
        component: RosterView,
      },


      {
        name: "bulk-credentials",
        path: "/employee/bulk-credentials",
        component: BulkCredentials,
      },
      {
        name: "bulk-update-roster",
        path: "/attendance/bulk-update-roster/:id",
        component: BulkUpdateRoster,
      },

      {
        name: "employee-document",
        path: "/employee/document",
        component: EmployeeDocument,
      },

      {
        name: "designation",
        path: "/employee/designation",
        component: Designation,
      },
      {
        name: "department",
        path: "/employee/department",
        component: Department,
      },
      {
        name: "overtime",
        path: "/employees/overtime",
        component: Overtime,
      },
      {
        name: "redemption-request",
        path: "/employees/redemption-request",
        component: RedemptionRequest,
      },

      {
        name: "credentials-management",
        path: "/employee/credentials-management",
        component: CredentialsManagement,
      },
      {
        name: "app-issue-reporting-list",
        path: "/help-support/app-issue-reporting",
        component: AppIssueReportingList,
      },
      {
        name: "app-issue-reporting-view",
        path: "/help-support/app-issue-reporting/view/:id",
        component: AppIssueReportingView,
      },
      {
        name: "user-profile",
        path: "/user-profile/:id",
        component: UserProfile,
      },
      {
        name: "candidate-profile",
        path: "/candidate-profile/:id",
        component: CandidateProfile,
      },
      {
        name: "country",
        path: "/basic-setup/country",
        component: Country,
      },
      {
        path: "/my-projects",
        name: "my-projects",
        component: MyProject,
      },
      {
        name: "my-letter",
        path: "/my-letter",
        component: MyLetter,
      },
      {
        name: "interview-type",
        path: "/basic-setup/interview-type",
        component: InterviewType,
      },

      {
        name: "inventory-type",
        path: "/basic-setup/inventory-type",
        component: InventoryType,
      },
      {
        name: "service-type",
        path: "/basic-setup/service-type",
        component: ServiceType,
      },

      {
        name: "email-template",
        path: "/basic-setup/email-template",
        component: EmailTemplate,
      },
      {
        name: "duty-type",
        path: "/basic-setup/duty-type",
        component: DutyType,
      },
      {
        name: "contract-type",
        path: "/basic-setup/contract-type",
        component: ContractType,
      },
      {
        name: "insurance-card",
        path: "/basic-setup/insurance-card",
        component: InsuranceCard,
      },
      {
        name: "employee-project",
        path: "/basic-setup/employee-project",
        component: EmployeeProject,
      },
      {
        name: "break-type",
        path: "/basic-setup/break-type",
        component: BreakType,
      },
      {
        name: "break-time",
        path: "/basic-setup/break-time",
        component: BreakTime,
      },
      {
        name: "shift-time",
        path: "/basic-setup/shift-time",
        component: ShiftTime,
      },
      {
        name: "change-break-time",
        path: "/basic-setup/change-break-time",
        component: ChangeBreakTime,
      },
      {
        name: "change-shift-time",
        path: "/basic-setup/change-shift-time",
        component: ChangeShiftTime,
      },
      {
        name: "experience",
        path: "/basic-setup/experience",
        component: Experience,
      },
      {
        name: "provident-fund-payroll",
        path: "/basic-setup/provident-fund",
        component: ProvidentFundPayroll,
      },
      {
        name: "career-level",
        path: "/basic-setup/career-level",
        component: CareerLevel,
      },
      {
        name: "higher-exactly",
        path: "/basic-setup/higher-exactly",
        component: HigherExactly,
      },
      {
        name: "recruitment-quota",
        path: "/basic-setup/recruitment-quota",
        component: RecruitmentQuota,
      },
      {
        name: "additional-resource",
        path: "/basic-setup/additional-resource",
        component: AdditionalResourceRequest,
      },
      {
        name: "organization",
        path: "/basic-setup/organization",
        component: Organization,
      },
      {
        name: "degree",
        path: "/basic-setup/degree",
        component: Degree,
      },
      {
        name: "state",
        path: "/basic-setup/state",
        component: State,
      },
      {
        name: "city",
        path: "/basic-setup/city",
        component: City,
      },
      {
        name: "leave-type",
        path: "/basic-setup/leave-type",
        component: LeaveType,
      },
      {
        name: "leaves-applicable",
        path: "/basic-setup/leaves-applicable",
        component: LeaveApplicable,
      },
      {
        name: "notification-type",
        path: "/notification-panel/notification-type",
        component: NotificationType,
      },
      {
        name: "leave-approver",
        path: "/basic-setup/leave-approver",
        component: LeaveApprover,
      },
      {
        name: "shift-assign",
        path: "/basic-setup/shift-assign",
        component: ShiftAssign,
      },

      {
        name: "grace-time",
        path: "/basic-setup/auto-check-out-limit",
        component: GraceTime,
      },
      {
        name: "part-time",
        path: "/basic-setup/part-time",
        component: PartTime,
      },
      {
        name: "late-coming",
        path: "/basic-setup/late-coming",
        component: LateComing,
      },

      {
        name: "half-day-policy",
        path: "/basic-setup/half-day-policy",
        component: HalfDayPolicy,
      },
      {
        name: "half-day-leave-policy",
        path: "/basic-setup/half-day-leave-policy",
        component: HalfDayLeavePolicy,
      },

      {
        name: "attendance_approvers",
        path: "/basic-setup/attendance_approvers",
        component: AttendanceApprovers,
      },
      {
        name: "approval-time",
        path: "/basic-setup/approval-time",
        component: ApprovalTime,
      },

      {
        name: "approval-sandwich",
        path: "/basic-setup/approval-sandwich",
        component: ApprovalSandwich,
      },

      {
        name: "late-adjustment",
        path: "/basic-setup/late-adjustment",
        component: LateAdjustment,
      },

      {
        name: "auto-attendance",
        path: "/basic-setup/auto-attendance",
        component: AutoAttendance,
      },
      {
        name: "teams",
        path: "/basic-setup/team",
        component: Teams,
      },
      {
        name: "blood-group",
        path: "/basic-setup/blood-group",
        component: BloodGroup,
      },
      {
        name: "marital-status",
        path: "/basic-setup/marital-status",
        component: MaritalStatus,
      },
      {
        name: "gender",
        path: "/basic-setup/gender",
        component: Gender,
      },
      {
        name: "bank",
        path: "/basic-setup/bank",
        component: Bank,
      },
      {
        name: "religion",
        path: "/basic-setup/religion",
        component: Religion,
      },
      {
        name: "nationality",
        path: "/basic-setup/nationality",
        component: nationality,
      },
      {
        name: "division",
        path: "/basic-setup/division",
        component: Division,
      },
      {
        name: "employment-status",
        path: "/basic-setup/employment-status",
        component: EmploymentStatus,
      },
      {
        name: "section",
        path: "/basic-setup/section",
        component: section,
      },
      {
        name: "contact-relation",
        path: "/basic-setup/contact-relation",
        component: ContactRelation,
      },
      {
        name: "document-type",
        path: "/basic-setup/document-type",
        component: DocumentType,
      },
      {
        name: "campaign",
        path: "/basic-setup/campaign",
        component: Campaign,
      },
      {
        name: "leave-renewal",
        path: "/basic-setup/leave-renewal",
        component: LeaveRenewal,
      },
      {
        name: "leave-history",
        path: "/basic-setup/leave-history",
        component: LeaveHistory,
      },
      {
        name: "leave-assign",
        path: "/basic-setup/leave-assign",
        component: LeaveAssign,
      },
      {
        name: "leave-approval-timeline",
        path: "/basic-setup/leave-approval-timeline",
        component: LeaveApprovalTimeline,
      },
      {
        name: "leave-request-timeline",
        path: "/basic-setup/leave-request-timeline",
        component: LeaveRequestTimeline,
      },
      {
        name: "type-form",
        path: "/basic-setup/type-form",
        component: TypeForm,
      },
      {
        name: "custom-field",
        path: "/basic-setup/custom-field",
        component: CustomField,
      },
      {
        name: "geo-fencing",
        path: "/basic-setup/geo-fencing",
        component: GeoFencing,
      },
      {
        name: "geo-fencing-create",
        path: "/basic-setup/geo-fencing/create",
        component: GeoFencingCreate,
      },
      {
        name: "geo-fencing-edit",
        path: "/basic-setup/geo-fencing/edit/:id",
        component: GeoFencingEdit,
      },
      {
        name: "geo-fencing-map",
        path: "/basic-setup/geo-fencing/map/:id",
        component: GeoFencingMap,
      },
      {
        name: "employment-level",
        path: "/control-panel/employment-level",
        component: EmploymentLevel,
      },
      {
        name: "employment-grade",
        path: "/control-panel/employment-grade",
        component: EmploymentGrade,
      },
      {
        name: "general-settings",
        path: "/control-panel/general-settings",
        component: GeneralSettings,
      },

      {
        name: "employee-settings",
        path: "/control-panel/employee-settings",
        component: EmployeeSettings,
      },

      {
        name: "letter-settings",
        path: "/control-panel/letter-settings",
        component: LetterSettings,
      },

      {
        name: "module-settings",
        path: "/control-panel/module-settings",
        component: ModuleSettings,
      },

      {
        name: "performance-settings",
        path: "/control-panel/performance-settings",
        component: PerformanceSettings,
      },

      {
        name: "approval-settings",
        path: "/control-panel/approval-settings",
        component: ApprolvalSettings,
      },

      {
        name: "notification-settings",
        path: "/control-panel/notification-settings",
        component: NotificationSettings,
      },

      {
        name: "application-settings",
        path: "/control-panel/application-settings",
        component: ApplicationSettings,
      },

      {
        name: "organization-settings",
        path: "/control-panel/organization-settings",
        component: OrganizationSettings,
      },
      {
        name: "asset-type",
        path: "/basic-setup/asset-type",
        component: AssetType,
      },
      {
        name: "asset-details",
        path: "/basic-setup/asset-details",
        component: AssetDetails,
      },
      {
        name: "inventory-details",
        path: "/basic-setup/inventory-details",
        component: InventoryDetails,
      },
      // {
      //   name: "assign-inventory",
      //   path: "/asset-and-services/assign-inventory",
      //   component: AssignInventory,
      // },
      // {
      //   name: "inventory-requests",
      //   path: "/asset-and-services/inventory-requests",
      //   component: InventoryRequests,
      // },
      {
        name: "asset-requests",
        path: "/asset-and-services/asset-requests",
        component: AssetRequests,
      },
      {
        name: "service-requests",
        path: "/asset-and-services/service-requests",
        component: ServiceRequests,
      },
      {
        name: "request-asset",
        path: "/asset-and-services/request-asset",
        component: RequestAsset,
      },
      {
        name: "request-inventory",
        path: "/asset-and-services/request-inventory",
        component: RequestInventory,
      },
      {
        name: "request-service",
        path: "/asset-and-services/request-service",
        component: RequestService,
      },
      {
        name: "service-records",
        path: "/asset-and-services/service-records",
        component: ServiceRecords,
      },
      {
        name: "inventory",
        path: "/asset-and-services/inventory",
        component: InventoryTabs,
      },
      {
        name: "card",
        path: "/asset-and-services/card",
        component: CardTabs,
      },

      {
        name: "asseset-card",
        path: "/basic-setup/card",
        component: Card,
      },

      {
        name: "asseset-assign-card",
        path: "/asset-and-services/assign-card",
        component: AssignCard,
      },

      {
        name: "card-request",
        path: "/asset-and-services/card-request",
        component: CardRequest,
      },

      {
        name: "company-services",
        path: "/asset-and-services/company-services",
        component: ServiceTabs,
      },
      {
        name: "assets",
        path: "/asset-and-services/assets",
        component: AssetTabs,
      },
      {
        name: "asset",
        path: "/asset",
        component: Asset,
      },
      {
        name: "my-assets",
        path: "/asset-and-services/my-assets",
        component: Assets,
      },

      {
        name: "my-loan-requests",
        path: "/ess/my-loan-requests",
        component: MyLoanRequests,
      },
      {
        name: "my-portal",
        path: "/ess/my-portal",
        component: MyPortal,
      },
      {
        name: "my-stars",
        path: "/ess/my-stars",
        component: MyStars,
      },

      {
        name: "my-advance-salary-requests",
        path: "/ess/my-advance-salary-requests",
        component: MyAdvanceSalaryRequests,
      },

      {
        name: "advance-salary-requests",
        path: "/payroll-management/advance-salary-requests",
        component: AdvanceSalaryRequests,
      },

      {
        name: "loan-requests",
        path: "/payroll-management/loan-requests",
        component: LoanRequests,
      },

      {
        name: "devices",
        path: "/attendance/devices",
        component: Devices,
      },

      {
        name: "device-type",
        path: "/attendance/device-type",
        component: DeviceType,
      },

      {
        name: "attendance-flag",
        path: "/attendance/attendance-flag",
        component: AttendanceFlag,
      },
      {
        name: "attendance-history",
        path: "/attendance/attendance-history",
        component: AttendanceHistory,
      },
      {
        name: "time-adjustment-request",
        path: "/attendance/time-adjustment-request",
        component: TimeAdjustmentRequest,
      },
      {
        name: "ncns",
        path: "/attendance/ncns",
        component: NCNS,
      },
      {
        name: "suspensions",
        path: "/attendance/suspensions",
        component: Suspension,
      },
      {
        name: "my-team-dashboard",
        path: "/my-team/my-team-dashboard",
        component: MyTeamDashboard,
      },
      {
        name: "team-management",
        path: "/my-team/team-management",
        component: TeamManagement,
      },
      {
        name: "team-attendance",
        path: "/my-team/team-attendance",
        component: TeamAttendance,
      },
      {
        name: "team-leave",
        path: "/my-team/team-leave",
        component: TeamLeave,
      },
      {
        name: "project",
        path: "/my-team/project",
        component: Project,
      },
      {
        name: "project-details",
        path: "/my-team/project/:id",
        component: ProjectView,
      },
      {
        name: "achievement",
        path: "/my-team/performance/achievement",
        component: Achievement,
      },

      {
        name: "my-team-performance-overview",
        path: "/my-team/performance/overview",
        component: MyTeamPerformanceOverview,
      },
      {
        name: "disciplinary-action",
        path: "/my-team/performance/disciplinary-action",
        component: DisciplinaryActions,
      },

      {
        name: "assessments",
        path: "/my-team/performance/assessments",
        component: Assesments,
      },

      {
        name: "achievement-list",
        path: "/performance-and-rewards/achievement-list",
        component: AchievementList,
      },

      {
        name: "performance-and-rewards-dashboard",
        path: "/performance-and-rewards/dashboard",
        component: PeformanceAndRewardsDashboard,
      },
      {
        name: "disciplinary-action-list",
        path: "/performance-and-rewards/disciplinary-action-list",
        component: DisciplinaryActionsList,
      },
      {
        name: "my-assessment-list",
        path: "/performance-and-rewards/my-assessment",
        component: MyAssesment,
      },

      {
        name: "my-feedback",
        path: "/performance-and-rewards/my-feedback",
        component: MyFeedback,
      },
      {
        name: "perormance-managment-achievement-list",
        path: "/performance-management/achievement-list",
        component: PerformanceAchievement,
      },
      {
        name: "perormance-managment-disciplinary-actions",
        path: "/performance-management/disciplinary-actions",
        component: PerformanceDisciplinaryActions,
      },

      {
        name: "weekly-holiday",
        path: "/holiday-management/weekly-holiday",
        component: WeeklyHoliday,
      },
      {
        name: "letter-applicable",
        path: "/letter-management/letter-applicable",
        component: LetterApplicable,
      },
      {
        name: "letter-type",
        path: "/letter-management/letter-type",
        component: LetterType,
      },
      {
        name: "letter-generation",
        path: "/letter-management/letter-generation",
        component: GenerateLetter,
      },

      {
        name: "issue-letter",
        path: "/letter-management/issue-letter",
        component: IssueLetter,
      },
      {
        name: "all-policies",
        path: "/letter-management/all-policies",
        component: AllPolicies,
      },

      {
        name: "slect-letter-type",
        path: "/letter-management/select-letter-type",
        component: SelectLetterType,
      },

      {
        name: "add-policy",
        path: "/letter-management/add-policy",
        component: AddPolicy,
      },
      {
        name: "update-policy",
        path: "/letter-management/update-policy/:id",
        component: AddPolicy,
      },

      {
        name: "all-incidents",
        path: "/letter-management/all-incidents",
        component: AllIncidents,
      },

      {
        name: "add-incident",
        path: "/letter-management/add-incident",
        component: AddIncident,
      },

      // {
      //   name: "incident-type",
      //   path: "/letter-management/incident-types",
      //   component: AllIncidents,
      // },

      {
        name: "all-letters",
        path: "/letter-management/all-letters",
        component: AllLetters,
      },

      {
        name: "add-letter",
        path: "/letter-management/add-letter",
        component: AddLetter,
      },

      {
        name: "update-letter",
        path: "/letter-management/update-letter/:id",
        component: UpdateLetter,
      },

      {
        name: "issue-letter-with-id",
        path: "/letter-management/issue-letter/:employeeId/:requestId/:letterId",
        component: IssueLetter,
      },
      {
        name: "update-incident",
        path: "/letter-management/update-incident/:id",
        component: UpdateIncident,
      },

      {
        name: "letter-request",
        path: "/letter-management/letter-request",
        component: LetterRequests,
      },
      {
        name: "gazette-holiday",
        path: "/holiday-management/gazette-holiday",
        component: GazetteHoliday,
      },

      {
        name: "handbook",
        path: "/organization/handbook",
        component: Handbook,
      },
      {
        name: "ess-hr-manual",
        path: "/organization/ess-hr-manual",
        component: EssHrManual,
      },
      {
        name: "handbook-details",
        path: "/organization/handbook-details",
        component: HandbookDetails,
      },
      {
        name: "hr-manual",
        path: "/organization/hr-manual",
        component: HrManual,
      },
         {
        name: "news-letter",
        path: "/organization/news-letter",
        component: NewsLetter,
      },
         {
        name: "week-poll",
        path: "/organization/week-poll",
        component: WeekPoll,
      },
      {
        name: "hr-documents",
        path: "/organization/hr-documents",
        component: HrDocuments,
      },
      {
        name: "notice-board",
        path: "/organization/notice-board",
        component: NoticeBoard,
      },

      {
        name: "my-target",
        path: "/targets/my-target",
        component: MyTargets,
      },
      {
        name: "check-attendance",
        path: "/attendance/check-attendance",
        component: CheckAttendance,
      },
      {
        name: "check-in-out",
        path: "/attendance/check-in-out",
        component: CheckInOut,
      },
      {
        name: "attendance-admin",
        path: "/attendance/attendance-admin",
        component: AttendanceAdmin,
      },
      {
        name: "roster",
        path: "/attendance/roster",
        component: Roster,
      },
      {
        name: "remote-geofence-creation",
        path: "/remote/geofence-creation",
        component: RemoteGeofenceCreation,
      },
      {
        name: "remote-geofence-assignment",
        path: "/remote/geofence-assignment",
        component: RemoteGeofenceAssignment,
      },
      {
        name: "wfh-attendance-logs",
        path: "/attendance/wfh-attendance-logs",
        component: WfhAttendanceLogs,
      },
      {
        name: "request-break-time-change",
        path: "/attendance/request-break-time-change",
        component: RequestBreakTimeChange,
      },
      {
        name: "request-shift-time-change",
        path: "/attendance/request-shift-time-change",
        component: RequestShiftTimeChange,
      },
      {
        name: "tax-slab",
        path: "/payroll-management/tax-slab",
        component: TaxSlab,
      },
      {
        name: "payroll-dashboard",
        path: "/payroll-management/payroll-dashboard",
        component: PayrollDashboard,
      },
      {
        name: "id-card-template",
        path: "/id-card-management/template",
        component: IdCardTemplate,
      },
      {
        name: "id-cards",
        path: "/id-card-management/id-cards",
        component: IdCardAdmin,
      },
      {
        name: "id-card",
        path: "/id-card-management/id-card-ess",
        component: IdCardEss,
      },
      {
        name: "ncns-type",
        path: "/payroll-management/ncns-type",
        component: NcnsType,
      },

      {
        name: "salary-type",
        path: "/payroll-management/salary-type",
        component: SalaryType,
      },
      {
        name: "pending-payroll",
        path: "/payroll-management/pending-payroll",
        component: PendingPayroll,
      },
      {
        name: "increment-approval-list",
        path: "/payroll-management/increment-approval-list",
        component: IncrementApprovalList,
      },
      {
        name: "approved-payroll",
        path: "/payroll-management/approved-payroll",
        component: ApprovedPayroll,
      },
      {
        name: "generate-payroll",
        path: "/payroll-management/generate-payroll",
        component: GeneratePayroll,
      },
      {
        name: "payroll-view",
        path: "/payroll-management/payroll/view/:id",
        component: PayrollView,
      },
      {
        name: "budget-payroll",
        path: "/payroll-management/budget-payroll",
        component: BudgetPayroll,
      },
      {
        name: "payroll-adjustment-category",
        path: "/payroll-management/payroll-adjustment-category",
        component: PayrollAdjustmentCategory,
      },
      {
        name: "payroll-adjustment",
        path: "/payroll-management/payroll-adjustment",
        component: PayrollAdjustment,
      },
      {
        name: "payroll-adjustment-view",
        path: "/payroll-management/payroll-adjustment/view/:id",
        component: PayrollAdjustmentView,
      },
      {
        name: "bulk-adjustment-upload",
        path: "/payroll-management/payroll-adjustment/bulk-adjustment-upload/:id",
        component: BulkAdjustmentUpload,
      },
      {
        name: "salary-slips",
        path: "/payroll-management/salary-slips",
        component: SalarySlips,
      },

      {
        name: "payment-mode",
        path: "/payroll-management/payment-mode",
        component: PaymentMods,
      },

      {
        name: "salary-slip-employees",
        path: "/payroll-management/salary-slip-employees/:id",
        component: SalarySlipEmployees,
      },

      {
        name: "salary-slip-view",
        path: "/payroll-management/payroll/salary-slip-view/:id",
        component: SalarySlipView,
      },
      {
        name: "salary-slip-user-view",
        path: "/payroll-management/payroll/salary-slip-user-view/:id",
        component: SalarySlipUserView,
      },
      {
        name: "tax-override",
        path: "/payroll-management/tax-override",
        component: TaxOverride,
      },

      {
        name: "salary",
        path: "/payroll-management/salary",
        component: Salary,
      },
      {
        name: "create-salary",
        path: "/payroll-management/create-salary",
        component: CreateSalary,
      },
      {
        name: "employment",
        path: "/employment",
        component: EmploymentForm,
      },
      // {
      //   name: "employment-form",
      //   path: "/employment/:id",
      //   component: EmploymentForm,
      // },

      {
        name: "edit-salary",
        path: "/payroll-management/edit-salary/:id",
        component: CreateSalary,
      },
      {
        name: "recruitment-dashboard",
        path: "/recruitment/recruitment-dashboard",
        component: RecruitmentDashboard,
      },
      {
        name: "recruitment-requisition",
        path: "/recruitment/recruitment-requisition",
        component: RecruitmentRequisition,
      },
      {
        name: "requisition-planning",
        path: "/recruitment/requisition-planning",
        component: RequisitionPlanning,
      },
      {
        name: "open-vacancies",
        path: "/recruitment/open-vacancies",
        component: OpenVacancies,
      },

      {
        name: "offer-letter-tab",
        path: "/recruitment/offer-letter-tab",
        component: OfferLetterTab,
      },
      // {
      //   name: "candidate-detail-form",
      //   path: "/recruitment/candidate-detail-form-crud",
      //   component: CandidateDetailForm,
      // },
      {
        name: "interview-logs",
        path: "/recruitment/interview-logs",
        component: InterviewLogs,
      },
      {
        name: "cv-bank",
        path: "/recruitment/cv-bank",
        component: CvBank,
      },
      {
        name: "internal-job-openings",
        path: "/ess/internal-job-openings",
        component: InternalJobOpenings,
      },
      {
        name: "my-referrals",
        path: "/ess/my-referrals",
        component: MyReferrals,
      },
      {
        name: "my-probation-details",
        path: "/ess/my-probation-details",
        component: MyProbationDetails,
      },
      {
        name: "manager-probation-evaluation",
        path: "/ess/manager-probation-evaluation",
        component: ManagerProbationEvaluation,
      },
      {
        name: "probation-details",
        path: "/employees/probation-details",
        component: ProbationDetails,
      },
      {
        name: "probation-evaluation",
        path: "/employees/probation-evaluation",
        component: ProbationEvaluation,
      },
      {
        name: "referrals",
        path: "/recruitment/referrals",
        component: Referrals,
      },
      {
        name: "candidate-information",
        path: "/recruitment/candidate-information",
        component: CandidateInformation,
      },
      {
        name: "recruitment-create-employee",
        path: "/recruitment/create-employee/:id",
        component: RecruitmentCreateEmployee,
      },
      // {
      //   name: 'recruitment-requisition-view',
      //   path: '/recruitment/recruitment-requisition/view/:id',
      //   component: RecruitmentRequisitionView
      // },
      {
        name: "manage-applicants",
        path: "/recruitment/manage-applicants",
        component: ManageApplicants,
      },
      // {
      //   name: 'in-process-applications',
      //   path: '/recruitment/in-process-applications',
      //   component: InProcessApplications
      // },
      // {
      //   name: 'process-interviews',
      //   path: '/recruitment/process-interviews',
      //   component: ProcessInterviews
      // },
      // {
      //   name: 'cancelled-interviews',
      //   path: '/recruitment/cancelled-interviews',
      //   component: CancelledInterviews
      // },
      // {
      //   name: 'hired-candidates',
      //   path: '/recruitment/hired-candidates',
      //   component: HiredCandidates
      // },
      // {
      //   name: 'rejected-candidates',
      //   path: '/recruitment/rejected-candidates',
      //   component: RejectedCandidates
      // },
      {
        name: "aptitude-test",
        path: "/recruitment/aptitude-test",
        component: AptitudeTest,
      },
      {
        name: "test-results",
        path: "/recruitment/test-results",
        component: TestResults,
      },

      {
        name: "roles-and-permissions",
        path: "/role-management/roles-and-permissions",
        component: RolesAndPermissions,
      },
      {
        name: "add-role",
        path: "/role-management/add-role",
        component: Permissions,
      },
      {
        name: "edit-role",
        path: "/role-management/edit-role/:id",
        component: Permissions,
      },
      {
        name: "assign-role",
        path: "/role-management/assign-role",
        component: AssignRole,
      },
      {
        name: "module-based-access",
        path: "/role-management/module-based-access",
        component: ModuleBasedAccess,
      },

      {
        name: "performance-dashboard",
        path: "/performance-management/performance-dashboard",
        component: PerformanceDashboard,
      },

      {
        name: "performance-management",
        path: "/performance-management/project-type",
        component: ProjectType,
      },

      {
        name: "performance-form",
        path: "/performance-management/evaluations-form",
        component: Form,
      },

      {
        name: "self-assesment",
        path: "/performance-and-rewards/self-assesment",
        component: SelfAssesment,
      },
      {
        name: "peer-assessment",
        path: "/performance-and-rewards/peer-assessment",
        component: PeerAssessment,
      },

      {
        name: "create-self-assesment",
        path: "/performance-and-rewards/create-self-assessment/:id",
        component: CreateSelfAssesment,
      },

      {
        name: "assessment-report",
        path: "/performance-and-rewards/assessment-report",
        component: AssessmentReport,
      },

      {
        name: "assign-form",
        path: "/performance-management/assign-form",
        component: AssignForm,
      },

      {
        name: "feedback",
        path: "/performance-management/feedback",
        component: Feedback,
      },

      {
        name: "performance-review",
        path: "/performance-management/performance-review",
        component: PerformanceReview,
      },

      {
        name: "my-forms",
        path: "/performance-management/my-forms",
        component: MyForms,
      },

      {
        name: "create-performance-review",
        path: "/performance-management/create-performance-review/:formId/:employeeId/:recordId/:directEmployee",
        component: CreatePerformanceReview,
      },

      {
        name: "update-performance-review",
        path: "/performance-management/update-performance-review/:employeeId/:reviewId/:formId/:distributionId",
        component: UpdatePerformanceReview,
      },

      {
        name: "form-frequnecy",
        path: "/performance-management/form-frequency",
        component: FormFrequency,
      },

      {
        name: "create-form",
        path: "/performance-management/create-evaluation-form",
        component: CreateForm,
      },

      {
        name: "update-form",
        path: "/performance-management/update-evaluation-form/:id",
        component: UpdateForm,
      },

      {
        name: "performance-report",
        path: "/performance-management/performance-report",
        component: PerformanceReport,
      },

      {
        name: "appraisals",
        path: "/performance-management/appraisals",
        component: Appraisals,
      },

      // Reports and analytics
      {
        name: "recruitment-reports",
        path: "/reports-and-analytics/recruitment-reports",
        component: RecruitmentReports,
      },
      {
        name: "employee-management-reports",
        path: "/reports-and-analytics/employee-management-reports",
        component: EmployeeManagementReports,
      },
      {
        name: "performance-management-reports",
        path: "/reports-and-analytics/performance-management-reports",
        component: PerformanceManagementReports,
      },
      {
        name: "payroll-reports",
        path: "/reports-and-analytics/payroll-reports",
        component: PayrollReports,
      },
      {
        name: "team-management-reports",
        path: "/reports-and-analytics/team-management-reports",
        component: TeamManagementReports,
      },
      {
        name: "additional-reports",
        path: "/reports-and-analytics/additional-reports",
        component: AdditionalReports,
      },
      {
        name: "basic-reports",
        path: "/reports-and-analytics/basic-reports",
        component: BasicReports,
      },
      {
        name: "time-and-attendance-reports",
        path: "/reports-and-analytics/time-and-attendance-reports",
        component: TimeAndAttendanceReports,
      },
      {
        name: "adhoc-report",
        path: "/reports-and-analytics/adhoc-report",
        component: AdhocReport,
      },
      {
        name: "productive-hours-report",
        path: "/reports-and-analytics/productive-hours-report",
        component: ProductiveHoursReport,
      },
      {
        name: "attendance-summary",
        path: "/reports-and-analytics/attendance-summary",
        component: AttendanceSummary,
      },
      {
        name: "attendance-detail-summary",
        path: "/reports-and-analytics/attendance-detail-report",
        component: AttendanceDetailReport,
      },
       {
        name: "attendance-consolidated-summary",
        path: "/reports-and-analytics/attendance-consolidated-report",
        component: AttendanceConsolidatedReport,
      },
      {
        name: "break-time-report",
        path: "/reports-and-analytics/break-time-report",
        component: BreakTimeReport,
      },
      {
        name: "leave-reports",
        path: "/reports-and-analytics/leave-reports",
        component: LeaveReports,
      },
      {
        name: "arrears-report",
        path: "/reports-and-analytics/arrears-report",
        component: ArrearsReport,
      },
      {
        path: "/attendance/my-attendance",
        name: "my-attendance",
        component: MyAttendance,
      },
      {
        name: "attendance-comprehensive-report",
        path: "/reports-and-analytics/attendance-comprehensive-report",
        component: AttendanceComprehensiceReport,
      },
      {
        path: "/two-factor-authentication",
        name: "two-factor-authentication",
        component: TwoFactorAuthentication,
      },
    ],
  },
  // {
  //   path: '/',
  //   name: 'login',
  //   component: Login
  // },
  {
    path: "/activities",
    name: "activities",
    component: Activities,
  },
  // {
  //   path: '/create-employee',
  //   name: 'create-employee',
  //   component: Create_Employee
  // },
  
  {
    path: "/basic-setup",
    name: "basic-setup",
    component: BasicSetup,
  },
  {
    path: "/change-password",
    name: "change-password",
    component: ChangePassword,
  },

  {
    path: "/leave/my-leaves",
    name: "my-leaves",
    component: LeavesEmployee,
  },

  {
    path: "/attendance-employee",
    name: "attendance-employee",
    component: AttendanceEmployee,
  },

  {
    path: "/otp",
    name: "otp",
    component: OTP,
  },
  {
    path: "/lock-screen",
    name: "lock-screen",
    component: Lock_Screen,
  },
  {
    path: "/error-500",
    name: "error-500",
    component: Error_500,
  },
  {
    path: "/error-404",
    name: "error-404",
    component: Error_404,
  },
  {
    path: "/error-403",
    name: "error-403",
    component: Error_403,
  },
  {
    path: "/blank-page",
    name: "blank-page",
    component: Blank_Page,
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: Privacy_Policy,
  },
  {
    path: "/terms",
    name: "terms",
    component: Terms,
  },
  {
    path: "/faq",
    name: "faq",
    component: Faq,
  },
  {
    path: "/settings",
    name: "settings",
    component: Settings,
  },

  // {
  //   path: '/leave-type',
  //   name: 'leave-type',
  //   component: LeaveType
  // }, // leave type is in basic setup

  {
    path: "/employee/profile",
    name: "profile",
    component: Profile,
  },
  {
    path: "/employee/profile/project-tasks/:id",
    name: "project-tasks",
    component: ProjectTasks,
  },

  // {
  //   path: '/salary',
  //   name: 'salary',
  //   component: Salary
  // },

  {
    path: "/tasks",
    name: "tasks",
    component: Tasks,
  },
  {
    path: "/task-board",
    name: "task-board",
    component: TaskBoard,
  },

  // {
  //   path: "/project-view",
  //   name: "project-view",
  //   component: ProjectView,
  // },
  // {
  //   path: "/termination",
  //   name: "termination",
  //   component: Termination,
  // },

  {
    name: "candidate-aptitude-test",
    path: "/aptitude-test/:id",
    component: CandidateAptitudeTest,
  },
  {
    name: "offer-letter",
    path: "/recruitment/offer-letter/:id",
    component: OfferLetter,
  },

  {
    // name: "notification-list",
    // path: "/notifications/notification-list",
    // component: Notifications,
  },

  {
    name: "accept-letter",
    path: "/employee/accept-letter",
    component: AcceptLetter,
  },
  { path: "/:pathMatch(.*)*", component: Error_404 },
];

export const router = createRouter({
  history: createWebHistory("/"),
  linkActiveClass: "active",
  routes,
});

const publicRoutes = [
  "/forgot-password",
  "/error-403",
  "/reset-password",
  "/verify-otp",
  "/verify-login-otp",
  "/careers",
  "/apply",
  "/aptitude-test/",
  "/recruitment/offer-letter",
  "/recruitment/candidate-detail-form/",
  "/change-password",
  "/installation-form-wizard",
];

router.beforeEach((to, from, next) => {
  window.scrollTo({ top: 0, behavior: "smooth" });

  // console.log("beforeEach", store.state.auth.isLoading);

  if (store.state.auth.isLoading) {
    // If auth check is not completed, wait until it is done
    const unwatch = store.watch(
      (state) => state.auth.isLoading,
      (isLoading) => {
        if (!isLoading) {
          unwatch(); // Stop watching once the auth check is done

          navigate(to, from, next);
        }
      }
    );
  } else {
    // If auth check is already done, proceed with navigation
    navigate(to, from, next);
    // store.dispatch("loading")
  }

  // Continue with the navigation
});

// -------- older function -----------
// function navigate(to, from, next) {
//   const authanticated = store.state?.auth?.user;
//   if (to.path === "/") {
//     if (authanticated) {
//       next("/admin-dashboard");
//     }
//     next();
//   }
//   console.log(
//     { authanticated },
//     !authanticated,
//     !publicRoutes.some((el) => to.path.startsWith(el))
//   );
//   if (
//     !authanticated &&
//     to.path !== "/" &&
//     !publicRoutes.some((el) => to.path.startsWith(el))
//   ) {
//     next("/");
//     // alert("redirect to login" + authanticated + store.state.auth.isLoading)
//   } else if (publicRoutes.some((el) => to.path.startsWith(el))) {
//     next();
//     store.dispatch("auth/loading", null);
//   } else {
//     // routes protection specific role(admin) permissions get added to seeder
//     try {
//       const userPermissions = store.state?.auth?.user?.permission;
//       const allPermissionKeys = Object.keys(allPermissionsWithRoutes);
//       const modifiedPermissions = {};
//       allPermissionKeys.forEach((el) => {
//         if (userPermissions.includes(el)) {
//           modifiedPermissions[el] = allPermissionsWithRoutes[el];
//         }
//       });
//       console.log("mod per", Object.keys(modifiedPermissions).length);
//       console.log("per", store.state?.auth?.user);

//       const userRoutes = Object.values(modifiedPermissions)
//         .flat(Infinity)
//         .map((el) => {
//           console.log("ellll", el, el.includes(":"));
//           if (el.includes(":")) {
//             return el.split(":")[0];
//           }
//           return el;
//         });

//       let hasAccess = false;
//       userRoutes.forEach((el) => {
//         if (to.path.startsWith(el)) {
//           hasAccess = true;
//         }
//       });

//       console.log("hasAccess", to.path, userRoutes);
//       // if (Array.isArray(to.path)) {
//       //   to.path.forEach((el) => {
//       //     if (userRoutes.includes(el)) {
//       //       hasAccess = true;
//       //     }
//       //   });
//       // } else {
//       //   hasAccess = userRoutes.includes(to.path);
//       // }

//       if (hasAccess) {
//         next();
//       } else {
//         next("/");
//       }
//     } catch (error) {
//       console.log("error fetching permissions", error);
//     }
//     next();
//     store.dispatch("auth/loading", null);
//   }

//   next();
//   store.dispatch("auth/loading", null);
// }
// --------- yesterday's function --------
async function navigate(to, from, next) {
  const authanticated = store.state?.auth?.user;
  
  if (!store.getters['app/isBootstrapped']) {
    console.log('router', store.getters['app/isBootstrapped'])
    await store.dispatch('app/bootstrap')
  }

  let installed = store.getters['app/isInstalled'];

  if (!installed && to.path !== '/installation-form-wizard') {
    return next('/installation-form-wizard')
  }

  if (installed && to.path === '/installation-form-wizard') {
    return next('/')
  }

  // Redirect authenticated users accessing the root to the dashboard
  // if (to.path === "/") {
  //   if (authanticated) {
  //     next("/admin-dashboard");
  //   } else {
  //     next();
  //   }
  //   return;
  // }

  // // Check if the route is public
  // const isPublicRoute = publicRoutes.some((el) => to.path.startsWith(el));

  // if (!authanticated && !isPublicRoute) {
  //   // Redirect unauthenticated users to the login page
  //   next("/");
  //   return;
  // }

  // if (isPublicRoute) {
  //   // Allow public routes
  //   next();
  //   store.dispatch("auth/loading", null);
  //   return;
  // }

  if (authanticated) {
    // Always redirect authenticated users to the employee dashboard when accessing root
    if (!window.Tawk_API) {
      loadTawkTo();
    }
    if (to.path === "/") {
      next("/employee-dashboard");
      return;
    }
  }

  const isPublicRoute = publicRoutes.some((el) => to.path.startsWith(el));

  if (!authanticated && !isPublicRoute) {
    // Redirect unauthenticated users to the login page
    if (to.path !== "/") {
      next("/");
    } else {
      next(); // Already at login page, allow navigation
    }
    return;
  }

  if (isPublicRoute) {
    next(); // Allow public routes
    store.dispatch("auth/loading", null);
    return;
  }

  if (
    to.path !== "/attendance/attendance-admin"
  ) {
    sessionStorage.clear();
  }

  // Routes with specific permissions
  try {
    const userPermissions =
      store.state?.auth?.user?.permission?.map((el) => el.name) || [];
    const allPermissionKeys = Object.keys(allPermissionsWithRoutes);

    // console.log("perm", userPermissions);
    // console.log("alllll", allPermissionKeys);

    // next();
    // Generate accessible routes based on user permissions
    // const accessibleRoutes = allPermissionKeys
    //   .filter((key) => userPermissions.includes(key))
    //   .flatMap((key) => allPermissionsWithRoutes[key])
    //   .map((route) => (route.includes(":") ? route.split(":")[0] : route));

    // console.log("routes", accessibleRoutes);
    // next();

    // const hasAccess = accessibleRoutes.some((route) =>
    //   to.path.startsWith(route)
    // );
    // console.log("has access", hasAccess);

    const modifiedPermissions = {};
    allPermissionKeys.forEach((el) => {
      if (userPermissions.includes(el)) {
        modifiedPermissions[el] = allPermissionsWithRoutes[el];
      }
    });

    const userRoutes = Object.values(modifiedPermissions)
      .flat(Infinity)
      .map((el) => {
        // console.log("ellll", el, el.includes(":"));
        if (el.includes(":")) {
          return el.split(":")[0];
        }
        return el;
      });

    let hasAccess = false;
    userRoutes.forEach((el) => {
      if (to.path.startsWith(el)) {
        hasAccess = true;
      }
    });

    if (hasAccess) {
      next();
    } else {
      if (to.path == "/attendance/wfh-attendance-logs") {
        if (
          store.state?.auth?.user?.hcm_id == "APD-1850" ||
          store.state?.auth?.user?.hcm_id == "APD-0998" ||
          store.state?.auth?.user?.hcm_id == "APD-1148"
        ) {
          next();
        }
      }
      // if (to.path == "/payroll-management/increment-approval-list") {
      //   if (
      //     store.state?.auth?.user?.hcm_id == "APD-0001" ||
      //     store.state?.auth?.user?.hcm_id == "APD-0002" ||
      //     store.state?.auth?.user?.hcm_id == "APD-0111"
      //   ) {
      //     next();
      //   }
      // }
      // Redirect if no access to the route
      next("/error-403");
    }
  } catch (error) {
    console.error("Error fetching permissions", error);
    next("/");
  } finally {
    store.dispatch("auth/loading", null);
  }
}

// --------- updated function -----------

// function navigate(to, from, next) {
//   const authanticated = store.state?.auth?.user;

//   // if (to.path === "/" && authanticated) {
//   //   const defaultDashboard = authanticated.role === "admin" ? "/admin-dashboard" : "/employee-dashboard";
//   //   // Prevent infinite redirection by checking current path
//   //   if (to.path !== defaultDashboard) {
//   //     next(defaultDashboard);
//   //   } else {
//   //     next(); // Allow navigation
//   //   }
//   //   return;
//   // }

//   if (authanticated) {
//     // Always redirect authenticated users to the employee dashboard when accessing root
//     if (to.path === "/" || to.path === "/admin-dashboard") {
//       next("/employee-dashboard");
//       return;
//     }
//   }

//   const isPublicRoute = publicRoutes.some((el) => to.path.startsWith(el));

//   if (!authanticated && !isPublicRoute) {
//     // Redirect unauthenticated users to the login page
//     if (to.path !== "/") {
//       next("/");
//     } else {
//       next(); // Already at login page, allow navigation
//     }
//     return;
//   }

//   if (isPublicRoute) {
//     next(); // Allow public routes
//     store.dispatch("auth/loading", null);
//     return;
//   }

//   try {
//     const userModels = store.state?.auth?.user?.model_name || [];
//     const allModelKeys = Object.keys(allPermissionsWithRoute);

//     // let accessibleRoutes = allModelKeys
//     //   .filter((key) => userModels.includes(key))
//     //   .flatMap((key) => allPermissionsWithRoute[key])
//     //   .map((route) => (route.includes(":") ? route.split(":")[0] : route));

//     // do not concat to accessibleRoutes like this its going in endless loop.
//     // accessibleRoutes = accessibleRoutes.concat([
//     //   "/employee-dashboard"/
//     //   "/employee/bulk-upload",
//     //   "/letter-management/all-incidents",
//     //   "/letter-management/add-incident",
//     //   "/letter-management/incident-types",
//     //   "/letter-management/select-letter-type"
//     // ]);

//     // const hasAccess = accessibleRoutes.some((route) =>
//     //   to.path.startsWith(route)
//     // );
//     // if (hasAccess) {
//     //   next();
//     // } else {
//     //   if (to.path !== "/") {
//     //     next("/"); // Redirect if no access
//     //   } else {
//     //     next();
//     //   }
//     // }
//     next();
//   } catch (error) {
//     console.error("Error fetching permissions", error);
//     next("/"); // Default redirection
//   } finally {
//     store.dispatch("auth/loading", null);
//   }
// }
